{
  "name": "participatory-system-mapper",
  "version": "3.3.3",
  "description": "Participatory System Mapper, browser app for collaboratively creating system maps",
  "keywords": [
    "social network",
    "participatory",
    "stakeholder",
    "policy analysis"
  ],
  "bugs": {
    "email": "n.gilbert@surrey.ac.uk"
  },
  "author": "Nigel Gilbert",
  "repository": {
    "type": "git",
    "url": "https://github.com/micrology/prsm"
  },
  "alias": {
    "devlop": "devlop/lib/default.js",
    "unist-util-visit-parents/do-not-use-color": "unist-util-visit-parents/lib/color.js",
    "three/webgpu": "three/build/three.webgpu.js",
    "three/tsl": "three/build/three.tsl.js"
  },
  "targets": {
    "default": {
      "distDir": "dist",
      "publicUrl": "."
    }
  },
  "browserslist": [
    "last 2 Chrome versions",
    "last 2 Firefox versions",
    "last 2 Safari versions",
    "last 2 Edge versions"
  ],
  "parcelIgnore": [
    "/doc/help/"
  ],
  "features": {
    "ai": true
  },
  "type": "module",
  "scripts": {
    "lint": "eslint --fix ./js/*.js",
    "pretty": "prettier --write ./html/*.html ./*.html ./js/*.js ./css/*.css doc/**/*.{html,css} package.json",
    "build-help": "cd doc/help && PRSM_DEPLOY=production npm run build",
    "build-help-locally": "cd doc/help && npm run build",
    "build-vis-network": "cd vis-network && npm run build",
    "spellcheck": "npx cspell './js/*.js' './html/*.html' './css/*.css' 'doc/help/docs/manual/*.mdx'",
    "check": "npm run lint && npm run spellcheck &&npm run build-help && npm run pretty",
    "dev": "npm run clean && npx parcel watch './html/*.html' --no-hmr",
    "build": "rm -rf dist/* && npx parcel build './html/*.html'",
    "jsdoc": "npx jsdoc -r -c .jsdoc.json",
    "clean": "rm -rf dist/*",
    "build-for-docker": "node ./utils/build-for-docker.mjs",
    "rebuild-docker": "npm run build-for-docker && docker buildx build -f docker/docker-y-websocket/Dockerfile --platform linux/amd64,linux/arm64 -t micrology/prsm-y-websocket --push . && docker buildx build --platform linux/amd64,linux/arm64 -t micrology/prsm-httpd --push -f docker/docker-httpd/Dockerfile .",
    "deploy": "npm run install:all && npm run build-vis-network && npm run build && npm run build-help",
    "analyse": "npx parcel build './html/*.html' --detailed-report",
    "install:all": "npm i && (cd ./doc/help && npm i) && (cd ./api-server && npm i) && (cd ./vis-network && npm i)  && (cd ./ws-server && npm i)",
    "upgrade:all": "npm upgrade && (cd ./doc/help && npm upgrade) && (cd ./api-server && npm upgrade) && (cd ./vis-network && npm upgrade) && (cd ./ws-server && npm upgrade)",
    "start:all-locally": "./utils/start-all-locally.sh",
    "stop:all-locally": "./utils/stop-all-locally.sh"
  },
  "license": "GPL-3.0-or-later",
  "dependencies": {
    "@aws-sdk/client-bedrock-runtime": "^3.965.0",
    "@aws-sdk/client-cognito-identity": "^3.965.0",
    "@aws-sdk/client-sts": "^3.965.0",
    "@egjs/hammerjs": "^2.0.17",
    "@jaames/iro": "^5.5.2",
    "@knadh/oat": "^0.6.0",
    "@popperjs/core": "^2.11.8",
    "3d-force-graph": "^1.74.5",
    "bootstrap": "^5.3.3",
    "component-emitter": "^1.3.0",
    "dompurify": "^3.4.2",
    "fabric": "^7.2.0",
    "fast-xml-parser": "^5.7.0",
    "file-saver": "^2.0.5",
    "keycharm": "^0.4.0",
    "level": "^10.0.0",
    "localforage": "^1.10.0",
    "luxon": "^3.2.1",
    "lz-string": "^1.4.4",
    "markdown-to-quill-delta": "^1.0.1",
    "marked": "^18.0.3",
    "qrcode": "^1.5.4",
    "quill": "^2.0.0",
    "quill-delta-to-html": "^0.12.1",
    "quill-to-word": "^1.3.0",
    "tabulator-tables": "^6.3.0",
    "three-spritetext": "^1.9.3",
    "uuid": "^11.1.1",
    "vis-data": "^8.0.0",
    "vis-util": "^6.0.0",
    "xlsx": "https://cdn.sheetjs.com/xlsx-0.20.3/xlsx-0.20.3.tgz",
    "y-websocket": "^3.0.0",
    "yjs": "^13.6.27"
  },
  "devDependencies": {
    "@eslint/js": "^10.0.1",
    "buffer": "^6.0.3",
    "crypto-browserify": "^3.12.1",
    "docdash": "^2.0.2",
    "eslint": "^10.9.1",
    "eslint-config-prettier": "^10.1.8",
    "jsdoc": "^4.0.2",
    "microdiff": "^1.3.1",
    "neostandard": "0.14.0-next.1",
    "os-browserify": "^0.3.0",
    "parcel": "^2.16.4",
    "parcel-resolver-ignore": "^2.2.1",
    "path-browserify": "^1.0.1",
    "prettier": "^3.4.2",
    "process": "^0.11.10",
    "stream-browserify": "^3.0.0",
    "stream-http": "^3.2.0"
  },
  "private": true,
  "optionalDependencies": {
    "@parcel/rust-linux-arm64-gnu": "^2.16.4",
    "@parcel/watcher-linux-arm64-glibc": "^2.6.0",
    "@parcel/watcher-linux-x64-glibc": "^2.6.0",
    "@swc/core-linux-arm64-gnu": "^1.15.2",
    "lightningcss-linux-arm64-gnu": "^1.30.2"
  }
}
